import axios from "axios";
import { environment } from "./environment";
// import { toast } from "react-toastify";
// import { environment } from "./environment";
// import swal from "sweetalert";

// axios.interceptors.request.use( config => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = 'Bearer ' + token;
//     }
//     return config;
//   },
//   function(error) {
//     return Promise.reject(error);
//   }
// );
axios.interceptors.response.use(response => {
  return response;
}, (error) => {
 if (error.response.status === 401) {
  // swal({
  //   title: "Your session has expired. Please redirected to the login page?",
  //   icon: "warning",
  //   // buttons: true,
  //   dangerMode: true,
  // }).then((willDelete) => {
  //   if (willDelete) {
  //     localStorage.removeItem("token");
  //     localStorage.removeItem("currentUser");
  //     localStorage.removeItem("role");
  //     localStorage.removeItem("status");
  //     window.location = '/'
  //   }
  // });
 } else if(error.response.status === 400){
  // toast.error(error.response.data.message, {
  //   position: toast.POSITION.TOP_RIGHT,
  //   autoClose: 3000,
  // });
 }
 return error;
});

// axios.interceptors.response.use(null, (error) => {
//   if (error.config && error.response && error.response.status === 401) {
//     console.log(error.config);
//      refreshToken();
//     axios.defaults.headers.common[
//       "Authorization"
//     ] = `Bearer ${localStorage.getItem("token")}`;
//     return axios.request(error.config);
//   }

//   return Promise.reject(error);
// });

// const refreshToken = async () => {
//    const params = {
//     refreshToken: localStorage.getItem("refreshToken")
//    }
//   try {
//     const res = await axios.put(environment.endPoint +"userAuth/refresh", params);
//     if (res.status === 200) {
//        console.log(res)
//       // localStorage.removeItem("refreshToken");
//       // localStorage.removeItem("token");
//     }
//   } catch (err) {
//     console.log(err);
//   }
// };

export default axios.create({
  baseURL: environment.endPoint + "/api",
  headers: {
    "Content-type": "application/json",
    "Authorization": `Bearer ${localStorage.getItem("token")}`
  },
});
